var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4L10.0003 6",
    stroke: "#BCBEC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 4L14.0003 6",
    stroke: "#BCBEC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9842 5.77231V5.77232H11.9891H15.4163C16.9745 5.77232 18.2503 7.04791 18.2503 8.60065V15.4217C18.2503 16.9744 16.9744 18.25 15.4163 18.25H8.58439C7.007 18.25 5.75048 16.9774 5.75048 15.4217V15.4217L5.75032 8.57832C5.75032 8.57832 5.75032 8.57831 5.75032 8.57831C5.75033 7.02632 7.02496 5.75127 8.58203 5.75L11.9842 5.77231Z",
    stroke: "#BCBEC3",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3267 8.69415C16.3267 9.18801 15.9264 9.5883 15.4326 9.5883C14.9387 9.5883 14.5384 9.188 14.5384 8.69415C14.5384 8.20029 14.9387 7.8 15.4326 7.8C15.9264 7.8 16.3267 8.2003 16.3267 8.69415Z",
    fill: "#BCBEC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52673 12.0828C9.52673 12.5767 9.12643 12.977 8.63275 12.977C8.13889 12.977 7.7386 12.5767 7.7386 12.0828C7.7386 11.589 8.1389 11.1887 8.63275 11.1887C9.12644 11.1887 9.52673 11.589 9.52673 12.0828Z",
    fill: "#BCBEC3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.938 12.0828C12.938 12.5767 12.5377 12.977 12.0439 12.977C11.55 12.977 11.1497 12.5767 11.1497 12.0828C11.1497 11.589 11.55 11.1887 12.0439 11.1887C12.5377 11.1887 12.938 11.589 12.938 12.0828Z",
    fill: "#BCBEC3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3267 12.0828C16.3267 12.5767 15.9264 12.977 15.4326 12.977C14.9387 12.977 14.5384 12.5767 14.5384 12.0828C14.5384 11.589 14.9387 11.1887 15.4326 11.1887C15.9264 11.1887 16.3267 11.589 16.3267 12.0828Z",
    fill: "#BCBEC3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52673 15.4949C9.52673 15.9888 9.12643 16.3891 8.63275 16.3891C8.13889 16.3891 7.7386 15.9888 7.7386 15.4949C7.7386 15.0011 8.1389 14.6008 8.63275 14.6008C9.12644 14.6008 9.52673 15.0011 9.52673 15.4949Z",
    fill: "#BCBEC3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.938 15.4949C12.938 15.9888 12.5377 16.3891 12.0439 16.3891C11.55 16.3891 11.1497 15.9888 11.1497 15.4949C11.1497 15.0011 11.55 14.6008 12.0439 14.6008C12.5377 14.6008 12.938 15.0011 12.938 15.4949Z",
    fill: "#BCBEC3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar.42e78587199ef6b8f6eb5ffa3f18cb25.svg";